import { BaseUsersClient } from "../types/clients";
import { RemoveUserResponse, User, UserWithPassword } from "@core/types";
import { convertParhatoUserToUser } from "./converters";

class UsersClient extends BaseUsersClient {
  async getProfile(userId: string): Promise<User> {
    const response = await this.instance.get(`/wp-json/wc/v3/customers/${userId}`);

    return convertParhatoUserToUser(response.data);
  }

  async updateProfile(userId: string, updateData: Partial<UserWithPassword>): Promise<Partial<User>> {
    const userPayload = {
      first_name: updateData.firstName,
      last_name: updateData.lastName,
      email: updateData.email || undefined,
      shipping: {
        first_name: updateData.firstName,
        last_name: updateData.lastName,
      },
      billing: {
        first_name: updateData.firstName,
        last_name: updateData.lastName,
        email: updateData.email || undefined,
        phone: updateData.phone,
      },
      password: updateData.password,
    };

    await this.instance.put<any>(`/wp-json/wc/v3/customers/${userId}`, {
      ...userPayload,
    });
    return updateData;
  }

  async deleteMe(): Promise<RemoveUserResponse> {
    throw new Error("deleteMe not implemented");
  }
}

export default UsersClient;
